import {useState} from 'react';
import {EvConfirm} from '../../modal/EvConfirm';
import {EvReactModal} from '../../modal/EvReactModal';
import {useCustomerRestoreMutation} from './useCustomerRestoreMutation';
import {clsx} from 'clsx';

interface Props {
  label?: string;
  customerId: number;
  customerName: string;
  restored: () => void;
}

export function CustomerRestoreButton(props: Props) {
  const [showModal, setShowModal] = useState<boolean>(false);
  const mutation = useCustomerRestoreMutation({id: props.customerId});

  const confirm: (confirmed: boolean) => void = (confirmed) => {
    if (!confirmed) {
      setShowModal(false);
      return;
    }

    mutation.mutate(() => props.restored());
  };

  return <>
    <button type="button"
            className={clsx({'btn-link': !props.label, 'btn-sm': !props.label}, 'btn', 'btn-default')}
            title="Kunde wiederherstellen"
            disabled={mutation.isPending}
            onClick={() => setShowModal(true)}>
      {props.label ? props.label : <i className="fa fa-refresh text-storz-green"/>}
    </button>

    <EvReactModal contentLabel={`Kunde ${props.customerId}: ${props.customerName}`}
                  showModal={showModal}
                  modalClosed={() => setShowModal(false)}>
      <EvConfirm response={confirm} responseLocked={mutation.isPending}>
        Soll der Kunde wirklich wiederhergestellt werden?
      </EvConfirm>
    </EvReactModal>
  </>;
}
